const ContextSection = () => {
  return (
    <section className="py-16 md:py-20 bg-[#F5F3EE]">
      <div className="section-container">
        <div className="max-w-2xl mx-auto">
          {/* Title */}
          <h2 className="text-xl md:text-2xl lg:text-3xl font-display font-normal mb-6 text-[#112711]">
            Por que a Allu está fazendo isso?
          </h2>
          
          {/* Context - secondary text */}
          <div className="space-y-4 text-sm md:text-base text-[#112711]/80 font-body leading-relaxed mb-6">
            <p>
              Ao longo dos últimos anos, nos relacionamos com milhares de clientes e investidores e percebemos um padrão recorrente:
            </p>
            
            <p className="text-[#112711]/70 italic pl-4 border-l-2 border-[#F3DE2C] text-sm">
              decisões financeiras relevantes costumam ser tomadas de forma isolada, sem uma visão integrada de patrimônio.
            </p>
            
            <p>
              Investimentos, impostos, estrutura patrimonial, objetivos de vida e sucessão precisam conversar entre si.
            </p>
          </div>
          
          {/* Main message */}
          <p className="text-sm md:text-base text-[#112711] font-body leading-relaxed">
            A ideia é ouvir — com profundidade — pessoas que já se preocupam com essas decisões de forma mais estratégica, para que você{" "}
            <span className="underline decoration-[#F3DE2C] decoration-2 underline-offset-4">
              receba um primeiro diagnóstico patrimonial completo.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContextSection;
